import React from 'react';

interface ApiKeyEditTabProps {
  formData: {
    name: string;
    key: string;
    phone: string;
    email: string;
    description: string;
  };
  formErrors: Record<string, string>;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onGenerateKey: () => void;
  onSave: () => Promise<void>;
  isLoading: boolean;
}

const ApiKeyEditTab: React.FC<ApiKeyEditTabProps> = ({
  formData,
  formErrors,
  onInputChange,
  onGenerateKey,
  onSave,
  isLoading
}) => {
  return (
    <div className="card border-0 shadow-sm">
      <div className="card-body">
        <div className="mb-3">
          <label htmlFor="name" className="form-label">
            Name <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className={`form-control ${formErrors.name ? 'is-invalid' : ''}`}
            id="name"
            name="name"
            value={formData.name}
            onChange={onInputChange}
            placeholder="Enter API key name"
          />
          {formErrors.name && (
            <div className="invalid-feedback">{formErrors.name}</div>
          )}
        </div>

        <div className="mb-3">
          <label htmlFor="key" className="form-label">
            API Key <span className="text-danger">*</span>
          </label>
          <div className="input-group">
            <input
              type="text"
              className={`form-control ${formErrors.key ? 'is-invalid' : ''}`}
              id="key"
              name="key"
              value={formData.key}
              onChange={onInputChange}
              placeholder="XXXXX-XXXXX-XXXXX"
            />
            <button
              className="btn btn-outline-secondary"
              type="button"
              onClick={onGenerateKey}
            >
              Generate
            </button>
            {formErrors.key && (
              <div className="invalid-feedback">{formErrors.key}</div>
            )}
          </div>
        </div>

        <div className="mb-3">
          <label htmlFor="phone" className="form-label">Phone</label>
          <input
            type="tel"
            className={`form-control ${formErrors.phone ? 'is-invalid' : ''}`}
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={onInputChange}
            placeholder="(XXX) XXX-XXXX"
          />
          {formErrors.phone && (
            <div className="invalid-feedback">{formErrors.phone}</div>
          )}
        </div>

        <div className="mb-3">
          <label htmlFor="email" className="form-label">Email</label>
          <input
            type="email"
            className={`form-control ${formErrors.email ? 'is-invalid' : ''}`}
            id="email"
            name="email"
            value={formData.email}
            onChange={onInputChange}
            placeholder="example@domain.com"
          />
          {formErrors.email && (
            <div className="invalid-feedback">{formErrors.email}</div>
          )}
        </div>

        <div className="mb-3">
          <label htmlFor="description" className="form-label">Description</label>
          <textarea
            className="form-control"
            id="description"
            name="description"
            value={formData.description}
            onChange={onInputChange}
            rows={3}
            placeholder="Enter description (optional)"
          ></textarea>
        </div>
      </div>
      <div className="card-footer bg-white">
        <div className="d-flex justify-content-end">
          <button
            type="button"
            className="btn btn-primary"
            onClick={onSave}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Saving...
              </>
            ) : (
              "Save Changes"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApiKeyEditTab;
